export const SharePollContent = {
    email: {
        subject: 'Pick a Side and Connect with Friends',
        body:
            'Hi,\n\n' +
            'I think you will like this:\n\n' +
            'SeleOne.com - Have fun comparing everything, sharing with your\n' +
            ' friends, and connecting with new ones. Pick a side and see what\n' +
            'others choose. Express yourself and create new trends!\n\n',
    },
    twitter: {
        title:
            'SeleOne.com - Have fun comparing everything, sharing with your ' +
            'friends, and connecting with new ones. Pick a side and see what ' +
            'others choose. Express yourself and create new trends!',
    },
    linkedin: {
        title: 'Pick a Side and Connect with Friends',
        summary:
            'SeleOne.com - Have fun comparing everything, sharing with your\n' +
            ' friends, and connecting with new ones. Pick a side and see what\n' +
            'others choose. Express yourself and create new trends!\n\n',
        source: 'SeleOne',
    },
    facebook: {
        quote:
            'SeleOne.com - Have fun comparing everything, sharing with your\n' +
            ' friends, and connecting with new ones. Pick a side and see what\n' +
            'others choose. Express yourself and create new trends!\n\n',
    },
};
